/*
 * @Description: enter your description
 * @Autor: zczhang
 * @Date: 2020-07-27 16:12:14
 * @LastEditors: zczhang
 * @LastEditTime: 2020-08-03 12:59:58
 */

const state = {
  wsInstance: [],
  warningData: []
}

const mutations = {
  setOnlineParam(state, payload) {
    let sbList = payload
    console.log('-------------------2')
    sbList.forEach(item => {
      state.wsInstance = state.wsInstance.filter(gItem => gItem.pulNo == item._id_pu)
    })
    console.log(state.wsInstance)
  },
  setGps(state, payload) {
    let { pulName, name, gps } = payload
    console.log('-------------------1')
    let flag = ''
    for (let i = 0; i < state.wsInstance.length; i++) {
      if (state.wsInstance[i].pulNo === name) {
        flag = name
        state.wsInstance[i] = {
          gps: gps,
          pulName: pulName,
          pulNo: name
        }
      }
    }
    if (flag === '') {
      state.wsInstance.push({
        gps: gps,
        pulName: pulName,
        pulNo: name
      })
    }
    console.log(state.wsInstance)
  },
  setWarningData(state, payload) {
    let { data } = payload
    state.warningData = data
    sessionStorage.setItem('warningData', JSON.stringify(data))
  }
}

const getters = {
  warningData: state => {
    !state.warningData &&
      (state.warningData = JSON.parse(sessionStorage.getItem('warningData')))
    return state.warningData
  },
  wsInstance: state => {
    return state.wsInstance
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/common.js